<ng-template #mobileMenuItem let-id="id" let-label="label" let-mainLinks="mainLinks">
  <a
    class="nav-link dropdown-toggle"
    href="#"
    id="navbarDropdown"
    role="button"
    data-bs-toggle="dropdown"
    aria-expanded="false"
    (click)="openMobileDropDown($event, id, currentShowMobileDropDownMenu)"
  >
    {{ label }}
  </a>
  <ul class="dropdown-menu" aria-labelledby="navbarDropdown" [ngClass]="{ show: currentShowMobileDropDownMenu === id }">
    <li *ngFor="let dropdownLink of mainLinks; let i2 = index">
      <a class="dropdown-item" href="#" (click)="goto($event, dropdownLink.link, dropdownLink)">{{
        dropdownLink.label
      }}</a>
    </li>
  </ul>
</ng-template>
<nav class="desktop navbar navbar-expand-lg d-none d-lg-block">
  <div class="container">
    <a class="navbar-brand" href="/" title="Főoldal">
      <img src="assets/images/logo.svg" />
    </a>
    <button
      class="navbar-toggler collapsed"
      aria-label="Menu"
      [attr.aria-expanded]="collapsedElem.classList.contains('show')"
      type="button"
      (click)="
        collapsedElem.classList.contains('show')
          ? collapsedElem.classList.remove('show')
          : collapsedElem.classList.add('show')
      "
    >
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="navbar-collapse collapse" id="mainNav" style="" #collapsedElem>
      <div class="navbar-nav mr-auto">
        <ng-container *ngFor="let navbarMainLink of navbarMainLinks; let i = index">
          <div
            class="nav-item dropdown"
            (click)="openHideMenuItem($event, i, navbarMainLink)"
            style="cursor: pointer"
            [ngClass]="openedMenu.indexOf(i) > -1 ? 'opened' : ''"
          >
            <a class="nav-link level_1 dropdown-toggle" href="#" title="Features">
              <span class="main-navigation">{{ navbarMainLink.label }}</span>
              <i *ngIf="navbarMainLink.mainLinks.length > 0" class="d-lg-inline-block fa fa-chevron-down"></i>
            </a>
            <div
              *ngIf="navbarMainLink.mainLinks.length > 0"
              class="dropdown-menu mega-menu"
              [ngClass]="'element-count-' + navbarMainLink.mainLinks.length"
              aria-labelledby="navbarDropdown"
              style="max-height: 0px"
              [ngStyle]="{
                'min-height.px':
                  (navbarMainLink.mainLinks.length <= 2
                    ? 240
                    : 120 * (navbarMainLink.mainLinks.length / 2 | mathCeil)) + 30
              }"
            >
              <div
                class="dropdown-container"
                [ngStyle]="{
                  'height.px':
                    navbarMainLink.mainLinks.length <= 2 ? 240 : 120 * (navbarMainLink.mainLinks.length / 2 | mathCeil),
                  'grid-template-rows': 'repeat(' + (navbarMainLink.mainLinks.length / 2 | mathCeil) + ', 1fr)'
                }"
              >
                <div
                  class="level-2-item possible-divider"
                  *ngFor="let dropdownLink of navbarMainLink.mainLinks; let i2 = index"
                  [attr.col]="(i2 + 1) % 2 === 0 ? 2 : 1"
                  [attr.ro]="(i2 + 1) / 2 | mathCeil"
                  [ngStyle]="{ 'grid-column': (i2 + 1) % 2 === 0 ? 2 : 1, 'grid-row': ((i2 + 1) / 2 | mathCeil) }"
                >
                  <a href="#" class="level_2" (click)="goto($event, dropdownLink.link, dropdownLink)">
                    <span class="level-2">{{ dropdownLink.label }}</span>
                    <p>{{ dropdownLink.subHead }}</p>
                  </a>
                </div>
                <div
                  class="level-2-item-last-column"
                  [ngStyle]="{
                    'grid-template-rows': 'repeat(' + navbarMainLink.articles.length + ', 1fr)',
                    'grid-row': '1/span ' + (navbarMainLink.mainLinks.length / 2 | mathCeil)
                  }"
                >
                  <div
                    class="level-2-item level-2-item-only-title"
                    *ngFor="let article of navbarMainLink.articles; let i3 = index"
                    [ngStyle]="{ 'grid-column': 1, 'grid-row': i3 + 1 }"
                  >
                    <a [href]="article.link | sanitizeUrl" (click)="closeMenu($event)" class="level_2" target="_blank">
                      <span class="level-2">{{ article.label }}</span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-container>

        <div class="nav-item d-block d-lg-none">
          <a class="nav-link level_1" [routerLink]="['csomagok-es-arak']" title="Regisztráció">
            <span>Regisztráció</span>
          </a>
        </div>
        <div class="nav-item d-block d-lg-none">
          <a class="nav-link level_1" (click)="onClickLogin()" title="Belépés">
            <span>Belépés</span>
          </a>
        </div>
      </div>
    </div>
    <div class="right-side-items d-none d-lg-block">
      <button type="button" class="menu-btn bemutato-btn nav-link me-3" [routerLink]="['csomagok-es-arak']">
        <span>Regisztráció</span>
      </button>
      <button type="button" class="menu-btn belepes-btn nav-link" (click)="onClickLogin()">
        <span>Belépés</span>
      </button>
    </div>
  </div>
</nav>
<nav class="navbar navbar-expand-lg navbar-light bg-light d-lg-none">
  <div class="container-fluid">
    <a class="navbar-brand" href="/" title="Főoldal">
      <img src="assets/images/logo.svg" />
    </a>
    <button
      class="navbar-toggler"
      type="button"
      data-bs-toggle="collapse"
      data-bs-target="#navbarSupportedContent"
      aria-controls="navbarSupportedContent"
      [attr.aria-expanded]="showMobileMenu"
      aria-label="Toggle navigation"
      (click)="onClickShowHideMobileMenu()"
    >
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" [ngClass]="{ show: showMobileMenu }" id="navbarSupportedContent">
      <ul class="navbar-nav me-auto mb-2 mb-lg-0">
        <ng-container *ngFor="let navbarMainLink of navbarMainLinks; let i = index">
          <li class="nav-item dropdown" *ngIf="navbarMainLink.mainLinks.length > 0; else simpleTpl">
            <ng-container
              *ngTemplateOutlet="
                mobileMenuItem;
                context: {
                  id: navbarMainLink.id,
                  label: navbarMainLink.label,
                  mainLinks: navbarMainLink.mainLinks
                }
              "
            ></ng-container>
          </li>
          <ng-template #simpleTpl>
            <li class="nav-item">
              <a
                class="nav-link"
                [title]="navbarMainLink.label"
                href="#"
                (click)="goto($event, navbarMainLink.link, navbarMainLink)"
                >{{ navbarMainLink.label }}</a
              >
            </li>
          </ng-template>
          <!--        <li class="nav-item">-->
          <!--          <a class="nav-link disabled">Disabled</a>-->
          <!--        </li>-->
        </ng-container>
        <li class="nav-item">
          <a class="nav-link" [routerLink]="['csomagok-es-arak']" title="Regisztráció">
            <span>Regisztráció</span>
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" (click)="onClickLogin()" title="Belépés">
            <span>Belépés</span>
          </a>
        </li>
      </ul>
    </div>
  </div>
</nav>
